export default __webpack_public_path__ + "static/video3-c40846e6c68e36f6904417a875776761.mp4";